/*
 * @Author: 'lek' '2889356275@qq.com'
 * @Date: 2025-05-13 11:26:52
 * @LastEditors: 'lek' '2889356275@qq.com'
 * @LastEditTime: 2025-05-13 11:43:55
 * @FilePath: \HTML和CSSe:\巴斯德\公司网站\bsd_website\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import WelcomePage from '../views/HomePage.vue'
import CompanyPage from '../views/CorporateCulture.vue'
import ProductsPage from '../views/CoreProducts.vue'
import LinksPage from '../views/LinksPage.vue'
import NotFound from '../views/NotFound.vue'

Vue.use(VueRouter)

const routes = [
  {
      path: '/',
      redirect: '/welcome'
  },
  {
      path: '/welcome',
      name: 'welcome',
      component: WelcomePage,
      meta: { requiresAuth: true }
  },
  {
      path: '/company',
      name: 'company',
      component: CompanyPage,
      meta: { requiresAuth: true }
  },
  {
      path: '/products',
      name: 'products',
      component: ProductsPage,
      meta: { requiresAuth: true }
  },
  {
      path: '/links',
      name: 'links',
      component: LinksPage,
      meta: { requiresAuth: true }
  },
  {
    path: '/404',
    name: 'NotFound',
    component: NotFound
  },
  {
    path: '*',
    redirect: '/404'
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes: routes
});

export default router
